import { render, staticRenderFns } from "./InspectionUserView.vue?vue&type=template&id=33adfa85&scoped=true&"
import script from "./InspectionUserView.vue?vue&type=script&lang=ts&"
export * from "./InspectionUserView.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionUserView.vue?vue&type=style&index=0&id=33adfa85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adfa85",
  null
  
)

export default component.exports